import { render, staticRenderFns } from "./FeedProductUsersTab.vue?vue&type=template&id=1850af4f&"
import script from "./FeedProductUsersTab.vue?vue&type=script&lang=ts&"
export * from "./FeedProductUsersTab.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports